export { default as Divider } from './src/divider';
